import { createRoot } from "react-dom/client";
import { DesktopRouter } from "./react/legacy/DesktopRouter";

// initialize react
const root = createRoot(getElementByIdOrThrow("react-app"));
root.render(<DesktopRouter />);

function getElementByIdOrThrow(id: string) {
  const result = document.getElementById(id);
  if (!result) {
    throw new Error(`Element #${id} not found`);
  }
  return result;
}
